export default "/packs/images/DSC05593~45514ceb42cefa80af936f4ba234e10c.jpg";